import React from 'react'
import { observer } from 'mobx-react'
import useCartContent from 'services/cart/hooks/use-cart-content'

function WhenCartIsNotEmpty (props) {
  const cartContent = useCartContent()

  if (cartContent.length < 1) return null

  return props.children
}

export default observer(WhenCartIsNotEmpty)
